export enum FormNames {
  Registration = "registrationForm",
  SignIn = "signInForm",
  ForgotPassword = "forgotPasswordForm",
  ResetPassword = "changePasswordFormNoAuth",
  EditProfile = "editProfileForm",
  PostLogin = "postLoginForm",
  ChangePassword = "changePasswordForm",
  ResendVerification = "resendVerificationForm",
  GenerateOtpForm = "generateMobileOtpForm",
  ValidateOtpForm = "validateOtpForm",
  ValidateEmailForm = "emailValidation"
};

export enum StatusCodes {
  Success = 0,
  FatalError = 1,
  ValidationError = 2,
  Unauthorized = 3
};

export const UserNotFoundError = {
  status: 403,
  message: "Missing user token"
};
